module.exports = __webpack_public_path__ + "static/media/fj.55c3d3a6.svg";